import sanitize from "sanitize-html";

export const FaqAccordion = ({ faqs }) => {
  return (
    <div
      className="accordion"
      id="accordionExample"
    >
      {faqs?.map((faq, index) => {
        return (
          <div
            className="accordion-item"
            key={index}
          >
            <h2
              className="accordion-header"
              id={`heading-${index}`}
            >
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse-${index}`}
                aria-expanded="false"
                aria-controls={`collapse-${index}`}
              >
                {faq.question}
              </button>
            </h2>
            <div
              id={`collapse-${index}`}
              className="accordion-collapse collapse"
              aria-labelledby={`heading-${index}`}
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <div
                  dangerouslySetInnerHTML={{ __html: sanitize(faq.answer) }}
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default function FaqsModal({ faqs }) {
  return (
    <div
      className="modal fade"
      id="faq-modal"
      tabIndex="-1"
      aria-labelledby="modalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h3
              className="modal-title body-2 fw-semi-bold"
              id="modalLabel"
            >
              {`FAQ's`}
            </h3>
            <button
              type="button"
              className="btn-close position-absolute top-0 end-0 m-0"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            {faqs?.length > 0 ? (
              <FaqAccordion faqs={faqs} />
            ) : (
              <div>No FAQ&apos;s available!</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

// Standalone FAQ component without modal
export function FaqsSection({ faqs }) {
  return (
    <div className="faq-container">
      {/* <h3 className="body-5 mb-0 fw-semi-bold">Faq</h3> */}
      {faqs?.length > 0 ? (
        <FaqAccordion faqs={faqs} />
      ) : (
        <div>No FAQ's available!</div>
      )}
    </div>
  );
}
